import { z } from 'zod/v4';

/**
 * Open "style bag" — the `styles` / `mobileStyles` maps every widget envelope
 * carries. Keys and values are JSS-driven and intentionally unvalidated, so the
 * shape stays a permissive record and is preserved verbatim on round-trip.
 *
 * Shared across all widgets (button, social, video, form, figure, text); kept
 * here rather than redeclared per widget.
 */
export const styleBagSchema = z.record(z.string(), z.unknown());
